/* eslint-disable no-console */
import React, { BaseSyntheticEvent, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Tooltip, Box, Button, CircularProgress, Typography } from '@mui/material';
import { AddPhotoAlternateOutlined, HideImageOutlined } from '@mui/icons-material';

import { DeleteModal } from './DeleteModal';
import { Edit } from '../../constructor/work/Edit';
import { ONLY_JPG } from '../../helpers/constants';
import { UrlParamsObjectType } from '../../constructor/types';
import { useUpdateProjectMutation } from '../../graphql/mutations/__generated__/updateProject';

export const ButtonAddTexture = () => {
  const [runUpdateProject] = useUpdateProjectMutation();
  const location = useLocation().state as UrlParamsObjectType;
  const [loadImage, setLoadImage] = useState(false);
  const [isLoadTexture, setIsLoadTexture] = useState(() => {
    return !!(Edit && Edit.drawingSubstrate);
  });
  const [isModalRemove, setIsModalRemove] = useState(false);

  const handleUploadImg = async (evt: BaseSyntheticEvent) => {
    setLoadImage(true);
    const file = evt.target.files[0];
    if (file) {
      try {
        setIsLoadTexture(true);
        Edit.addingDrawing(file);
      } catch (err: any) {
        console.log(err?.message);
      } finally {
        setLoadImage(false);
      }
    }
  };
  const handleRemoveImg = () => {
    Edit.removeDrawing();
    setIsLoadTexture(false);
    setIsModalRemove(false);

    runUpdateProject({
      variables: {
        code: location.code,
        background_base64: null,
        background_info: null,
      },
    }).then();
  };
  const openModal = () => {
    setIsModalRemove(true);
  };

  return (
    <>
      <Box width="100%" mb="20px">
        <LightTooltip title={ONLY_JPG} placement="top-start" arrow>
          <Button
            fullWidth
            variant="outlined"
            startIcon={isLoadTexture ? <HideImageOutlined /> : <AddPhotoAlternateOutlined />}
            onClick={isLoadTexture ? openModal : undefined}
            sx={{
              '&': {
                border: '1px solid #97A408',
                borderRadius: '10px',
                height: '50px',
                color: '#fff',
              },
            }}
          >
            {loadImage && <CircularProgress size={20} sx={{ color: '#e5e5e5' }} />}
            {!loadImage && (
              <>
                <Typography color="#e5e5e5" fontSize="14px">
                  {isLoadTexture ? 'Удалить чертеж' : 'Добавить чертёж'}
                </Typography>
                {!isLoadTexture && (
                  <input
                    style={{
                      position: 'absolute',
                      opacity: 0,
                      cursor: 'pointer',
                      width: '100%',
                      height: '100%',
                    }}
                    type="file"
                    onChange={handleUploadImg}
                  />
                )}
              </>
            )}
          </Button>
        </LightTooltip>
      </Box>
      {isModalRemove && (
        <DeleteModal closeModal={() => setIsModalRemove(false)} handlerDelete={handleRemoveImg} />
      )}
    </>
  );
};

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: 'black',
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);
